import { render, staticRenderFns } from "./detaillist.vue?vue&type=template&id=336bf6ae&scoped=true&"
import script from "./detaillist.vue?vue&type=script&lang=js&"
export * from "./detaillist.vue?vue&type=script&lang=js&"
import style0 from "./detaillist.vue?vue&type=style&index=0&id=336bf6ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336bf6ae",
  null
  
)

export default component.exports